import DefaultModal from "../DefaultModal";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import React, {Component} from "react";
import Select from "../../../local_node_modules/react-select";
import NumberFormat from "react-number-format";
import {value} from "lodash/seq";
import {isValidKonaklamaVergisiModalData} from "../../../common/componentValidation";
import {Decimal} from "decimal.js";
import Alert from "react-s-alert";
import Select2, {Option} from "rc-select";
import {deepCopyObject} from "../../../helper/helper";

class KonaklamaModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            trdDocInvoiceLine: this.props.invoiceLine,
            brut: this.props.invoiceLine.brut,
            net: this.props.invoiceLine.net,
            quantity: this.props.invoiceLine.quantity,
            unit: "DAY",
            kdvPercentage: this.props.invoiceLine.trdDocInvoiceLineCharges[1].percentage,
            suffixPercentage: this.props.invoiceLine.trdDocInvoiceLineCharges[0].percentage,
            konaklamaVergisiPercentage: 2,
            amount: this.props.invoiceLine.totalPrice,
            lineExtensionAmount: this.props.invoiceLine.lineExtensionAmount,
            itemName: this.props.invoiceLine.itemName
        }
        this.validateMessage = this.validateMessage.bind(this);
        this.calculate = this.calculate.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeUnit = this.onChangeUnit.bind(this);

    }

    componentDidMount = () => {
        let invoiceLine = this.props.invoiceLine;
        invoiceLine = deepCopyObject(invoiceLine);
        this.setState({invoiceLine});
    }


    onChangeUnit(e) {
        this.setState({unit: e.target.value});
    }

    onChange(e) {
        let {name, value} = e;
        this.setState({[name]: value});
    }

    clean = () => {
        this.setState({
            itemName: "",
            konaklamaVergisiAmount: 0,
            brut: 0,
            net: 0,
            quantity: 1,
            unit: "",
            kdvPercentage: 20,
            suffixPercentage: 0,
            konaklamaVergisiPercentage: 2,
            amount: "",
            unitPrice: 0,
            kdvAmount: 0
        });
    }


    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    calculate(apply) {
        let result = isValidKonaklamaVergisiModalData(this.state);
        let error = result.error;
        let valid = result.valid;
        let invoiceLine = this.props.invoiceLine;
        if (valid) {
            let {
                itemName,
                brut,
                quantity,
                unit,
                kdvAmount,
                suffixAmount,
                konaklamaVergisiAmount,
                konaklamaVergisiPercentage,
                amount,
                unitPrice,
                suffixPercentage,
                kdvPercentage
            } = this.state;
            brut = parseFloat(amount);
            if (quantity > 0 && !apply) {
                unitPrice = ((brut / ((1 + (konaklamaVergisiPercentage / 100) + (kdvPercentage / 100) ))) / (1 - (suffixPercentage / 100))) / quantity;
                suffixAmount = parseFloat(unitPrice*quantity) * (suffixPercentage / 100);
                kdvAmount = parseFloat(unitPrice*quantity-suffixAmount) * (kdvPercentage / 100);
                konaklamaVergisiAmount = parseFloat(unitPrice*quantity-suffixAmount) * (konaklamaVergisiPercentage / 100);
                this.setState({brut, suffixAmount, unitPrice, kdvAmount, konaklamaVergisiAmount, unit});
            } else if (quantity > 0 && apply) {
                unitPrice = ((brut / ((1 + (konaklamaVergisiPercentage / 100) + (kdvPercentage / 100) ))) / (1 - (suffixPercentage / 100))) / quantity;
                suffixAmount = parseFloat(unitPrice*quantity) * (suffixPercentage / 100);
                kdvAmount = parseFloat(unitPrice*quantity-suffixAmount) * (kdvPercentage / 100);
                konaklamaVergisiAmount = parseFloat(unitPrice*quantity-suffixAmount) * (konaklamaVergisiPercentage / 100);
                this.setState({brut, suffixAmount, unitPrice, kdvAmount, konaklamaVergisiAmount, unit});
                let chargeList = [];
                chargeList.push(
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 5,
                            code: "0000",
                            shortName: "İSKONTO",
                            longName: "İSKONTO",
                            direction: -1,
                            calculatedBy: "AMOUNT",
                            priority: -1,
                            affectTaxableAmount: 1,
                            mm: 0,
                            smm: 0,
                            inv: 1,
                            isAffectKdv: 1
                        },
                        calculateBy: "AMOUNT",
                        calculateFrom: "percentage",
                        percentage: suffixPercentage,
                        amount: new Decimal(new Decimal(suffixAmount).toFixed(2)).toNumber(),
                        direction: -1,
                        exemptionReasonCode: null,
                        exemptionReason: null,
                        perUnitAmount: 0,
                        calculatedBy: "AMOUNT",
                        taxableAmount: new Decimal(new Decimal(parseFloat(unitPrice*quantity)).toFixed(2)).toNumber(),
                        withholdingCode: "000"
                    },
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 37,
                            code: "0059",
                            shortName: "KONAKLAMA VERGİSİ",
                            longName: "KONAKLAMA VERGİSİ",
                            direction: 1,
                            calculatedBy: "AMOUNT",
                            priority: 2,
                            affectTaxableAmount: 1,
                            mm: 0,
                            smm: 1,
                            inv: 1,
                            isAffectKdv: 0
                        },
                        calculateBy: "AMOUNT",
                        calculateFrom: "percentage",
                        percentage: konaklamaVergisiPercentage,
                        amount: new Decimal(new Decimal(konaklamaVergisiAmount).toFixed(2)).toNumber(),
                        direction: 1,
                        exemptionReasonCode: null /*'001'*/,
                        exemptionReason: null /*'Diplomatik İstisna'*/,
                        perUnitAmount: 0,
                        calculatedBy: "AMOUNT",
                        taxableAmount: new Decimal(new Decimal(parseFloat(unitPrice*quantity-suffixAmount)).toFixed(2)).toNumber(),
                        withholdingCode: "000"
                    }
                    ,
                    {
                    recordId: null,
                    taxCode: {
                        recordId: 1,
                        code: "0015",
                        shortName: "KDV GERCEK",
                        longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                        direction: 1,
                        calculatedBy: "AMOUNT",
                        priority: 4,
                        affectTaxableAmount: 0,
                        mm: 0,
                        smm: 1,
                        inv: 1,
                        isAffectKdv: 0
                    },
                    calculateBy: "AMOUNT",
                    calculateFrom: "percentage",
                    percentage:  kdvPercentage,
                    amount:  new Decimal(new Decimal(kdvAmount).toFixed(2)).toNumber(),
                    direction: 1,
                    exemptionReasonCode: null,
                    exemptionReason: null,
                    perUnitAmount: 0,
                    calculatedBy: "AMOUNT",
                    taxableAmount: new Decimal(new Decimal(parseFloat(unitPrice*quantity-suffixAmount)).toFixed(2)).toNumber(),
                    withholdingCode: null
                }
                );
                invoiceLine = {
                    recordId: null,
                    itemCode: null,
                    itemName: itemName,
                    unit: unit,
                    quantity: quantity,
                    unitPrice: new Decimal(new Decimal(unitPrice).toFixed(2)).toNumber(),
                    lineExtensionAmount: new Decimal(new Decimal(parseFloat(unitPrice*quantity-suffixAmount)).toFixed(2)).toNumber(),
                    trdDocInvoiceLineCharges: chargeList,
                    trdDocInvoiceLineDeliveryDetail: null,
                }
                this.props.listener(invoiceLine);
                this.setState({invoiceLine: invoiceLine}, this.props.toggleModal);
            }
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right', effect: 'stackslide', timeout: 8000
            });
            this.setState({error: error});
        }
    }


    render() {
        let {
            brut,
            quantity,
            unit,
            kdvPercentage,
            itemName,
            suffixPercentage,
            konaklamaVergisiPercentage,
            amount,
            konaklamaVergisiAmount,
            unitPrice,
            suffixAmount,
            kdvAmount
        } = this.state;
        return (
            <div>
                <DefaultModal disabled={this.state.btnDisabled}
                              size="lg"
                              isOpen={this.props.konaklamaModal}
                              title="Konaklama Vergisi Hesaplama"
                              confirmBtnText="Hesapla ve Uygula"
                              cancelBtnText="Kapat"
                              onConfirm={() => this.setState({btnDisabled: false}, () => {
                                  this.calculate(true)
                              })}
                              onCancel={(e) => this.setState({btnDisabled: false}, () => {
                                  this.props.toggleModal(false);
                              })}>
                    <Row style={{paddingLeft: 0, margin: "0px"}} className="baseDashboard">
                        <React.Fragment>
                            <Col sm={6} className="">
                                <label sm={12} style={{fontSize: 14, fontWeight: "bold", paddingBottom: "5px"}}>Konaklama
                                    Vergisi</label>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={10} style={{fontWeight: "bold"}}>Ürün/Hizmet Adı*</Label>
                                        <Col sm={12}>
                                            <Input
                                                id="itemName"
                                                value={itemName}
                                                onChange={(e) => this.onChange({
                                                    value: e.target.value,
                                                    name: "itemName"
                                                })} className={"form-control"}/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={10} style={{fontWeight: "bold"}}>Miktar</Label>
                                        <Col sm={12}>
                                            <Input
                                                id="quantity"
                                                value={quantity}
                                                onChange={(e) => this.onChange({
                                                    value: e.target.value,
                                                    name: "quantity"
                                                })}/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={10} style={{fontWeight: "bold"}}>Birim</Label>
                                        <Col sm={12}>
                                            <Select2
                                                placeholder="Birim Seçiniz"
                                                defaultValue="DAY"
                                                value={unit}
                                                style={{width: "100%"}}
                                                dropdownMenuStyle={{maxHeight: 200}}
                                                optionLabelProp="children"
                                                notFoundContent="Kayıt bulunamadı"
                                                optionFilterProp="text"
                                                getPopupContainer={(node) => {
                                                    return node.parentNode;
                                                }}
                                                onChange={(e) => this.onChangeUnit({
                                                    target: {
                                                        value: e,
                                                        name: "unit"
                                                    }
                                                })}>
                                                {this.props.unitCodes.map(unitCodes =>
                                                    <Option text={unitCodes.longCode} value={unitCodes.shortCode}
                                                            title={unitCodes.longCode}>{unitCodes.longCode}</Option>
                                                )}
                                            </Select2>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={6} style={{fontWeight: "bold"}}>KDV Oranı: *</Label>
                                        <Col sm={12}>
                                            <Select
                                                clearable={false}
                                                searchable={false}
                                                disabled={false}
                                                className="select-control"
                                                value={(kdvPercentage === null || kdvPercentage === undefined) ? 0 : kdvPercentage}
                                                placeholder="Seçiniz..."
                                                onChange={e => this.onChange({
                                                    value: e.value,
                                                    name: "kdvPercentage"
                                                })}
                                                options={[
                                                    {value: 0, label: "0%"},
                                                    {value: 1, label: "1%"},
                                                    {value: 8, label: "8%"},
                                                    {value: 10, label: "10%"},
                                                    {value: 18, label: "18%"},
                                                    {value: 20, label: "20%"}
                                                ]}
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={6} style={{fontWeight: "bold"}}>İskonto Oranı: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="suffixPercentage"
                                                          value={(suffixPercentage === null || suffixPercentage === undefined) ? 0 : suffixPercentage}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={2}
                                                          suffix={'%'}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "suffixPercentage"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={6} style={{fontWeight: "bold"}}>Konaklama Vergisi</Label>
                                        <Col sm={12}>
                                            <Select
                                                clearable={false}
                                                searchable={false}
                                                disabled={false}
                                                closeOnSelect={false}
                                                className="select-control"
                                                value={(konaklamaVergisiPercentage === null || konaklamaVergisiPercentage === undefined) ? 0 : konaklamaVergisiPercentage}
                                                placeholder="Seçiniz..."
                                                onChange={e => this.onChange({
                                                    value: e.value,
                                                    name: "konaklamaVergisiPercentage"
                                                })}
                                                options={[{value: 2, label: "2%"}]}
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={6} style={{fontWeight: "bold"}}>Tutar *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="amount"
                                                          value={amount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "amount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <Row style={{margin: "0px"}}>
                                        <Col sm={6}>
                                            <Button color="default" size="sm" block
                                                    onClick={this.clean}>Temizle</Button>
                                        </Col>
                                        <Col sm={6}>
                                            <Button color="info" size="sm" block
                                                    onClick={() => this.calculate(false)}>Hesapla</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Col>
                            <hr></hr>
                            <Col sm={6} className="row">
                                <label sm={12} style={{fontSize: 14, fontWeight: "bold", paddingBottom: "5px"}}>Hesaplama
                                    Sonucu</label>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={5} style={{fontWeight: "bold"}}>Brüt: </Label>
                                        <Col sm={12}>
                                            <NumberFormat value={brut}
                                                          decimalScale={2}
                                                          fixedDecimalScale={true}
                                                          disabled={!this.state.isManualResult}
                                                          suffix={this.props.suffix}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "brut"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={8} style={{fontWeight: "bold"}}>İskonto Tutarı: </Label>
                                        <Col sm={12}>
                                            <NumberFormat value={suffixAmount}
                                                          decimalScale={2}
                                                          fixedDecimalScale={true}
                                                          disabled={!this.state.isManualResult}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "suffixAmount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={8} style={{fontWeight: "bold"}}>Konaklama Vergisi Tutarı:</Label>
                                        <Col sm={12}>
                                            <NumberFormat value={konaklamaVergisiAmount}
                                                          decimalScale={2}
                                                          fixedDecimalScale={true}
                                                          disabled={!this.state.isManualResult}
                                                          suffix={this.props.suffix}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "konaklamaVergisiAmount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={8} style={{fontWeight: "bold"}}>Kdv Tutarı: </Label>
                                        <Col sm={12}>
                                            <NumberFormat value={kdvAmount}
                                                          decimalScale={2}
                                                          fixedDecimalScale={true}
                                                          disabled={true}
                                                          suffix={this.props.suffix}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdvAmount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={5} style={{fontWeight: "bold"}}>Birim Fiyat: </Label>
                                        <Col sm={12}>
                                            <NumberFormat value={unitPrice}
                                                          decimalScale={2}
                                                          fixedDecimalScale={true}
                                                          disabled={!this.state.isManualResult}
                                                          suffix={this.props.suffix}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "unitPrice"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                            </Col>
                        </React.Fragment>
                    </Row>
                </DefaultModal>
            </div>
        )
    }
}

export default KonaklamaModal;